export const state = () => ({
  mediaEnded: { finished: false, saveToStorgae: false },
  mediaError: false,
  playingUID: null,
});

export const mutations = {
  SET_PLAYING_UID(state, uid) {
    state.playingUID = uid;
  },

  SET_MEDIA_ENDED(state, mediaEnded) {
    state.mediaEnded = mediaEnded;
  },

  SET_MEDIA_ERROR(state, value) {
    state.mediaError = value;
  },
};

export const actions = {
  setPlayingUID({ commit }, uid) {
    commit('SET_PLAYING_UID', uid);
  },

  setMediaEnded({ commit }, mediaEnded) {
    commit('SET_MEDIA_ENDED', mediaEnded);
  },

  setMediaError({ commit }, mediaError) {
    commit('SET_MEDIA_ERROR', mediaError);
  },

  reset({ commit }) {
    commit('SET_MEDIA_ENDED', { finished: false, saveToStorgae: false });
    commit('SET_MEDIA_ERROR', false);
  },
};

export default {
  namespaced: true,
  registered: false,
  state,
  mutations,
  actions,
};
